import type { ReactNode } from 'react'
import React from 'react'

import { pluralize } from '@fourthwall/utils/dist/string'

import * as S from './styled'

type Props = {
  rules?: ReactNode[]
  hiddenBadgesCount?: number
  children: ReactNode
}

export const BadgeTableCell = ({ rules, children, hiddenBadgesCount }: Props) => (
  <S.Container>
    {children}
    {rules && rules.length > 0 && (
      <S.Rules>
        {hiddenBadgesCount && hiddenBadgesCount > 0
          ? `+ ${hiddenBadgesCount} ${pluralize(hiddenBadgesCount, 'badge')}`
          : null}
        {rules.map((rule, index) => (
          <p key={index}>{rule}</p>
        ))}
      </S.Rules>
    )}
  </S.Container>
)
